import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './SolutionsDropdown.module.css';
import {
    BarChart3,
    Building2,
    ShoppingCart,
    Video,
    Phone,
    Users
} from 'lucide-react';

const SolutionsDropdown = () => {
    const navigate = useNavigate();

    const industries = [
        {
            name: 'SaaS and Technology',
            slug: '/solutions/industries/saas-technology',
            icon: <BarChart3 className={styles.icon} />,
        },
        {
            name: 'BFSI, Loan, and Insurance',
            slug: '/solutions/industries/bfsi-insurance',
            icon: <Building2 className={styles.icon} />,
        },
        {
            name: 'FMCG',
            slug: '/solutions/industries/fmcg',
            icon: <ShoppingCart className={styles.icon} />,
        }
    ];

    const useCases = [
        {
            name: 'Online Meeting Intelligence',
            slug: '/solutions/use-cases/online-meetings',
            icon: <Video className={styles.icon} />,
        },
        {
            name: 'Phone Conversation Intelligence',
            slug: '/solutions/use-cases/phone-intelligence',
            icon: <Phone className={styles.icon} />,
        },
        {
            name: 'In-Person Meeting Intelligence',
            slug: '/solutions/use-cases/field-sales',
            icon: <Users className={styles.icon} />,
        }
    ];

    const handleLinkClick = (slug) => {
        navigate(slug);
    };

    return (
        <div className={styles.megaMenu}>
            <div className={styles.menuContent}>
                <div className={styles.section}>
                    <h3 className={styles.sectionTitle}>Industries</h3>
                    <div className={styles.linksGrid}>
                        {industries.map((item) => (
                            <div
                                key={item.slug}
                                className={styles.menuItem}
                                onClick={() => handleLinkClick(item.slug)}
                            >
                                <div className={styles.iconWrapper}>{item.icon}</div>
                                <div className={styles.itemText}>
                                    <p className={styles.itemName}>{item.name}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className={styles.section}>
                    <h3 className={styles.sectionTitle}>Use Cases</h3>
                    <div className={styles.linksGrid}>
                        {useCases.map((item) => (
                            <div
                                key={item.slug}
                                className={styles.menuItem}
                                onClick={() => handleLinkClick(item.slug)}
                            >
                                <div className={styles.iconWrapper}>{item.icon}</div>
                                <div className={styles.itemText}>
                                    <p className={styles.itemName}>{item.name}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SolutionsDropdown;
